import { PartnerPhoto } from "../../services/storageService";
import { Download } from "./download";
import { FlowType } from "./upload";

export class Photo {
	public readonly fileId: string;
	public readonly code: string;
	public readonly name: string;
	public readonly description: string;
	public readonly originalFilename: string;
	public readonly thumbUrl: string;
	public mediumUrl: string;
	public readonly width: number;
	public readonly height: number;
	public rotate90: number;
	public readonly fileSize: number;
	public readonly dateTaken: Date;
	public readonly dateUploaded: Date;
	public readonly dateModified: Date;
	public readonly folderId: string;
	public readonly hash: string;

	private relativeMediumUrl: string;
	private mediumUrlOriginal: string;

	constructor(
		id: string,
		name: string,
		dateTaken: Date,
		dateModified: Date,
		dateUploaded: Date,
		description: string,
		fileSize: number,
		folderId: string | null,
		height: number,
		mediumUrl: string,
		originalFileName: string,
		thumbUrl: string,
		width: number,
		rotate90: number,
		relativeMediumUrl: string,
		hash: string | null,
	) {
		this.fileId = id;
		this.code = id;
		this.name = name;
		this.dateTaken = dateTaken;
		this.dateModified = dateModified;
		this.dateUploaded = dateUploaded;
		this.description = description;
		this.width = width;
		this.height = height;
		this.originalFilename = originalFileName;
		this.thumbUrl = thumbUrl;
		this.mediumUrl = mediumUrl;
		this.rotate90 = rotate90;
		this.relativeMediumUrl = relativeMediumUrl;
		this.mediumUrlOriginal = mediumUrl;
		this.fileSize = fileSize;
		this.setMediumUrl();
		this.folderId = folderId || "";
		this.hash = hash || "";
	}

	public rotate90Cw() {
		this.rotate90 = this.rotate90 + (90 % 360);
		this.setMediumUrl();
	}

	private setMediumUrl() {
		this.mediumUrl = this.rotate90 !== 0 ? this.relativeMediumUrl + "&rot90=" + this.rotate90 : this.mediumUrlOriginal;
	}
}

export enum DownloadItemStates {
	WaitingForDownload = 0,
	Downloaded = 1,
	DownloadError = 2,
	Imported = 3,
	ImportError = 4,
	NotFound = 5,
}

/** For communication with client download and the core.downloader */
export interface IDownloadItem {
	/** eXpress mediastore file id*/
	readonly mediastoreFileId: string;
	/** Partner ref id*/
	readonly photoId: string;
	readonly name: string;
}

export interface IDownloadQueueItem {
	state: DownloadItemStates;
	errorMessage?: string;
	downloadedItem?: IDownloadItem;
	itemToDownload: PartnerPhoto;
}

export class Downloader {
	public download: Download;
	public flowType: FlowType;

	// Todo: implement ProgressPopup
	//public progressPopup: ProgressPopup;

	constructor(flowType: FlowType, token: string, productCategoryGroupCode: string) {
		this.download = new Download(token, productCategoryGroupCode, this);
		this.flowType = flowType;
		//this.progressPopup = popup;
	}

	/** Add photo's to the download queue */
	public async addToQueueAsync(photos: PartnerPhoto[]): Promise<Photo[]> {
		if (!photos || !photos.length) return Promise.resolve([]);

		//this.progressPopup.openAsync();

		const downloadItems = await this.download.addToQueueAsync(photos, this.flowType);
		return downloadItems.map(
			(di) =>
				new Photo(
					di.downloadedItem!.mediastoreFileId,
					di.itemToDownload.name,
					di.itemToDownload.dateTaken,
					di.itemToDownload.dateModified,
					di.itemToDownload.dateUploaded,
					di.itemToDownload.description,
					di.itemToDownload.fileSize,
					null,
					di.itemToDownload.height,
					di.itemToDownload.mediumUrl,
					di.itemToDownload.originalFilename,
					di.itemToDownload.thumbUrl,
					di.itemToDownload.width,
					0,
					di.itemToDownload.mediumUrl,
					null,
				),
		);
		//.always(() => this.progressPopup.close(true));
	}

	// update uploadprogress screen
	public handleDownloadItem(totalItems: number, itemsDone: number): void {
		const amount = totalItems + 1 - itemsDone;
		//this.progressPopup.updateProgress(amount);
	}
}
